// The target phrases as study material, in STORY order with meaning and example
// — what you read before you practise.
//
// Deliberately not PhraseChecklist, which shows the same phrases weakest-first
// as a live scoreboard. Ordering by drill priority is right during a session and
// wrong here: on the lesson page the phrases should read in the order they occur
// in the story you just read.

export default function PhraseList({ coverage }) {
  const phrases = coverage?.phrases || [];
  const total = coverage?.total || 0;
  const practiced = coverage?.practiced || 0;

  if (phrases.length === 0) {
    return (
      <p className="text-sm text-slate-500">
        This story has no phrase list — the coach will drill its own wording.
      </p>
    );
  }

  return (
    <div>
      <div className="mb-3 flex items-baseline justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400">
          Target phrases
        </h2>
        <span className="text-xs tabular-nums text-slate-500">
          {practiced}/{total} practised
        </span>
      </div>

      <ul className="divide-y divide-slate-800 rounded-xl border border-slate-800 bg-slate-900/40">
        {phrases.map((p) => (
          <li key={p.phrase} className="flex gap-3 px-4 py-3">
            <span
              className={`mt-1 h-1.5 w-1.5 shrink-0 rounded-full ${
                p.count > 0 ? "bg-emerald-500" : "bg-slate-700"
              }`}
              title={p.count > 0 ? `practised ${p.count}×` : "not practised yet"}
            />
            <div className="min-w-0">
              <div className="text-sm text-slate-200">{p.phrase}</div>
              {p.meaning && (
                <div className="text-xs text-slate-500">{p.meaning}</div>
              )}
              {p.example && (
                <div className="mt-1 text-xs italic text-slate-600">“{p.example}”</div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
